import { stringifyError } from '@luxon/utils';

type TLogMethod = (message: string, data?: any) => void;
interface ILogger {
  error: TLogMethod;
  warn: TLogMethod;
  info: TLogMethod;
  debug: TLogMethod;
}

const stringifyLogData = (data?: any): string => {
  if (!data || typeof data === 'string')  {
    return (data ?? '') as string;
  }
  return stringifyError(data);
}

export const logger: ILogger = ({
  error: (message: string, data?: any) => {
    const logData = stringifyLogData(data);
    console.error(message, data);
    if (window.newrelic) {
      window.newrelic.noticeError(data && data instanceof Error ? data : message, {
        errorData: logData,
        errorMessage: message
      });
    }
  },
  warn: (message: string, data?: any) => console.warn(message, data),
  info: (message: string, data?: any) => console.info(message, data),
  debug: (message: string, data?: any) => console.debug(message, data),
})